<template>
  <div class="warp">
    <!-- 顶部蓝色条 -->
    <div class="top">
      <span class="top_span">商户信息管理系统</span>
    </div>

    <div class="user_edit">
      <span>{{ modify ? "修改用户信息" : "添加用户信息" }}</span>
    </div>
    <!-- 信息部分 -->
    <!-- 用户信息修改 -->
    <div class="demo_warp">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="addForm"
        label-width="150px"
        label-position="right"
      >
        <el-row>
          <el-col :span="spanCol">
            <el-form-item label="二维码编号:" prop="code">
              <el-input  placeholder="请输入二维码编号" :disabled='modify'  v-model="ruleForm.code"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="spanCol">
            <el-form-item label="企业名称:" prop="company">
              <el-input placeholder="请输入企业名称"  v-model="ruleForm.company"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="spanCol">
            <el-form-item label="是否签订责任书:" prop="isContract">
              <el-select v-model="ruleForm.isContract">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="spanCol">
            <el-form-item label="统一社会信用代码:" prop="society">
              <el-input placeholder="请输入信用代码" v-model="ruleForm.society"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="经营范围:" prop="manage">
          <el-input
          placeholder="请输入经营范围"
            :autosize="autosize(3)"
            type="textarea"
            v-model="ruleForm.manage"
          ></el-input>
        </el-form-item>

        <el-row>
          <el-col :span="spanCol">
            <el-form-item label="所属街道：" prop="street">
              <el-select
                v-model="ruleForm.street"
                placeholder="请选择街道"
                @change="streetChange"
              >
                <el-option
                  v-for="item in allStreets"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="spanCol">
            <el-form-item label="所属社区：" prop="community">
              <el-select v-model="ruleForm.community" placeholder="请选择社区">
                <el-option
                  v-for="item in chooseCommunity"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="spanCol">
            <el-form-item label="地址:" prop="address">
              <el-input placeholder="请输入地址" v-model="ruleForm.address"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="spanCol">
            <el-form-item label="责任人:" prop="responsibility">
              <el-input placeholder="请输入责任人"  v-model="ruleForm.responsibility"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="spanCol">
            <el-form-item label="责任人身份证号:" prop="identityCard">
              <el-input placeholder="请输入身份证号" v-model="ruleForm.identityCard"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="spanCol">
            <el-form-item label="法定代表人电话:" prop="lawPhone">
              <el-input placeholder="请输入法定代表人电话" v-model="ruleForm.lawPhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="spanCol">
            <el-form-item label="责任人联系电话:" prop="resPhone">
              <el-input placeholder="请输入责任人联系电话" v-model="ruleForm.resPhone"></el-input>
            </el-form-item>
          </el-col>
           <el-col :span="spanCol">
            <el-form-item label="所属网格:" prop="belongGrid">
              <el-input  placeholder="请输入所属网格" v-model="ruleForm.belongGrid"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

    


        <el-form-item label="文字描述:" prop="description">
          <el-input
            type="textarea"
            :autosize="autosize(3)"
            v-model="ruleForm.description"
          ></el-input>
        </el-form-item>
      </el-form>

      <el-row class="btn-group">
        <button class="btn btn-confirm" @click="submitForm">确 定</button>
        <button class="btn ml-20" @click="goBack">返 回</button>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import emitter from "../utils/emitter";
import { community, allStreets } from "../utils";
export default {
  name: "add",
  data() {
    return {
      // 表单对象
      ruleForm: {
        code: undefined,
        company: undefined,
        isContract: undefined,
        society: undefined,
        manage: undefined,
        community: undefined,
        address: undefined,
        street: undefined,
        responsibility: undefined,
        identityCard: undefined,
        lawPhone: undefined,
        resPhone: undefined,
        description: undefined,
        belongGrid:undefined
      },
      spanCol: 12,
      allStreets: allStreets(),
      community: community(),
      id: undefined,
      modify: false, // 是否修改
    };
  },
  computed: {
    chooseCommunity() {
      return this.community[this.ruleForm.street] || [];
    },

    rules() {
      const needRequired = {
        required: true,
        message: "不能为空",
      };

      const validatorPhone = {
        validator: this.validatorPhone,
        trigger: "change",
      };
      
const valcode = {
        validator: this.valcode,
        trigger: "change",
      };

      const validentityCard = {
        validator: this.validentityCard,
        trigger: "change",
      };

      const valSociety = {
        validator: this.valSociety,
        trigger: "change",
      };
      return {
        code: [needRequired,valcode],
        company: [needRequired],
        isContract: [needRequired],
        society: [needRequired, valSociety],
        manage: [needRequired],
        community: [needRequired],
        street: [needRequired],
        address: [needRequired],
        responsibility: [needRequired],
        lawPhone: [validatorPhone],
        resPhone: [needRequired, validatorPhone],
        identityCard: [needRequired, validentityCard],
       
      };
    },
  },
  methods: {
    streetChange() {
      this.ruleForm.community = undefined;
    },

    autosize(minRows) {
      return { minRows };
    },
     valcode(rule, value, callback) {
      //  两位字母5位数字
      const pat = /^[A-Z]{2}\d{5}$/;
      if (value && !pat.test(value)) {
        callback("二维码编号格式不正确");
      }
      callback();
    },
    valSociety(rule, value, callback) {
      const pat = /^[0-9A-Z]+$/;
      if (value && !pat.test(value)) {
        callback("社会信用代码格式不正确");
      }
      callback();
    },
    validentityCard(rule, value, callback) {
      const pat = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (value && !pat.test(value)) {
        callback("身份证号码格式不正确");
      }
      callback();
    },
    validatorPhone(rule, value, callback) {
       const pat2 = /^0752-\d{7}$/
       const pat1 = /^\d{7}$/
      const pat = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (value && (!pat.test(value)&&!pat1.test(value)&&!pat2.test(value) )) {
        callback("手机号格式不正确");
      }
      callback();
    },

    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          this.addMessage();
        }
      });
    },

    addMessage() {
      const add_url = this.modify
        ? "/api/admin/merchantInfo/updateMerchantInfo"
        : "/api/admin/merchantInfo/saveMerchantInfo";
      const {
        code,
        company,
        isContract,
        society,
        responsibility,
        resPhone,
        lawPhone,
        manage,
        street,
        community,
        identityCard,
        description,
        address,
         belongGrid,
      } = this.ruleForm;
      const { id } = this;
      axios[this.modify ? "put" : "post"](add_url, {
        qrNumber: code,
        ownerPhone: resPhone, //责任人联系电话
        enterpriseName: company, //企业名称
        responsibilityFlag: isContract, //是否签订责任书,
        socialCreditNumber: society, //统一社会信用代码
        businessScope: manage, //经营范围
        address, //地址
        belongCommunity: community, //所属社区
        belongStreet: street, //所属街道
        owner: responsibility, //责任人
        ownerIdentityNumber: identityCard, //责任人身份证号
        legalRepresentativePhone: lawPhone, //法定代表人电话
        remark: description, //文字描述
        id,
         belongGrid: belongGrid
      })
        .then((res) => {
          const { success, message } = res.data;
          if (success) {
            this.$message({
              type: "info",
              message: this.modify ? "修改成功!" : "添加成功!",
            });
            this.goBack();
          } else {
            throw message || (this.modify ? "修改失败!" : "添加失败!");
          }
        })
        .catch((e) => {
          this.$alert(e || (this.modify ? "修改失败!" : "添加失败!"), "提 示", {
            type: "warning",
          });
        });
    },

    goBack() {
      this.$router.push({
        name: "home",
      });
    },

    init() {
      const message = this.$route.query.row;

      if (message) {
        this.modify = true;
        this.ruleForm.code = message.qrNumber;
        this.ruleForm.society = message.socialCreditNumber;
        this.ruleForm.street = message.belongStreet;
        this.ruleForm.community = message.belongCommunity;
        this.ruleForm.address = message.address;
        this.ruleForm.lawPhone = message.legalRepresentativePhone;
        this.ruleForm.resPhone = message.ownerPhone;
        this.ruleForm.identityCard = message.ownerIdentityNumber;
        this.ruleForm.responsibility = message.owner;
        this.ruleForm.company = message.enterpriseName;
        this.ruleForm.isContract = message.responsibilityFlag;
        this.ruleForm.description = message.remark;
        this.ruleForm.manage = message.businessScope;
        this.id = message.id;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>

<style scoped>
.warp {
  width: 100%;
  height: 900px;
  background-color: #fff;
}

.top {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  background-color: #1f2942;
}
/*  */

.top_span {
  margin-left: 24px;
  width: 192px;
  height: 24px;
  font-family: MicrosoftYaHei;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
}
/* 添加商户信息 */

.user_edit {
  width: 792px;
  height: 20px;
  border-bottom: 1px solid #1f6acb;
  margin: auto;
  margin-top: 40px;
  margin-bottom: 33px;
  line-height: 20px;
}

.user_edit span {
  width: 84px;
  height: 15px;
  font-family: MicrosoftYaHei-Bold;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #1f6acb;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

.demo_warp {
  margin: 0 auto;
  width: 792px;
}

.demo_warp .btn-group {
  text-align: center;
}

.demo_warp /deep/ .el-select {
  width: 100%;
}

.demo_warp .btn {
  width: 81px;
  height: 36px;
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: #333;
  border-radius: 4px;
  border: 1px solid #1f6acb;
  background-color: #fff;
  outline: none;
}

.demo_warp .btn-confirm {
  background-color: #1f6acb;
  color: #fff;
}

.ml-20 {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/add.vue